import React from 'react'

import CountUpWrapper from 'src/components/CountUpWrapper'
import Progress       from './Progress'

import formatNumber from 'src/utils/formatNumber'

const Goal = ({ hybrid_raised_with_matching, goal, total_donors }) =>
  <div className="p-2 overlay rounded-3" id="total-raised">
    <h2 className="h4 mb-0">
      <CountUpWrapper amount={hybrid_raised_with_matching} prefix="$" />
      <small className="text-slightly-muted fw-normal fs-5">
        { goal > 0
          ? ` of $${formatNumber(goal).split('.')[0]} goal `
          : ' in donations '
        }
        raised by
        {' '}
        <CountUpWrapper amount={total_donors} />
        {' '}
        {total_donors == 1 ? 'person' : 'people'}
      </small>
    </h2>
    { goal > 0 ?
      <Progress raised={hybrid_raised_with_matching} goal={goal} />
      : null
    }
  </div>

export default Goal
